export const parseAssociationMasterIds = (value: unknown): string[] => {
  if (!value) return []
  if (Array.isArray(value)) return value.filter((v): v is string => typeof v === 'string' && v.trim().length > 0)
  if (isString(value)) return value.split(/[\s,;]+/).filter(Boolean)
  return []
}

export const getProductAssociations = (buckets: AssociationBuckets): ProductAssociationsDataLayer => {
  const skus = associationTypeConfigs.reduce<Record<string, string[]>>((acc, cfg) => {
    const ids = buckets[cfg.key]?.items.map((item) => item.masterId) ?? []
    if (ids.length) acc[cfg.key] = ids
    return acc
  }, {})
  const types = Object.keys(skus)

  return { hasAssociations: types.length > 0, types, typeCount: types.length, skus }
}

export const productAssociationsForDataLayer = (
  associations?: ProductAssociationsDataLayer,
): ProductAssociationsDataLayer | undefined => {
  if (!import.meta.client || !tryUseNuxtApp()) return undefined
  if (!useFeatureFlags().productAssociationsEnabled()) return undefined

  return associations
}
